// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9fc3438e","186":"339ef376","272":"8659baac","372":"90ce8fcc","377":"115fcd5c","738":"556a1e88","841":"b9122f75","851":"99866f64","856":"638e4dad"}[chunkId] + ".chunk.js";
};